import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFaceitComponent } from './simple-icons-faceit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFaceitComponent ],
    exports:      [ SimpleIconsFaceitComponent ],
    bootstrap:    []
})
export class SimpleIconsFaceitModule {}
